module.exports = __webpack_public_path__ + "static/media/106.6544d7c2.jpg";